export default __webpack_public_path__ + "static/media/person.2bfb3413.svg";